import { Component, Input, Output, EventEmitter, ElementRef, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-multi-selection-dropdown',
  templateUrl: './multi-selection-dropdown.component.html',
  styleUrls: ['./multi-selection-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectionDropdownComponent),
      multi: true
    }
  ]
})
export class MultiSelectionDropdownComponent implements ControlValueAccessor, OnInit, OnChanges {

  @Input() _internalValue = '';
  @Input() required: boolean;
  @Input() placeholder = 'Selecione';
  @Input() id = '';
  @Input() options = [];
  @Input() value = '';
  @Input() disabled = false;
  @Input() invalid = false;
  @Input() height = 0;

  optionsAsValue: any[];
  public touched = false;

  @Output() changed = new EventEmitter<any>();

  constructor(private eRef: ElementRef) { }

  originalOptions = [];
  label = '';
  selected = [];
  isOpen = false;
  defaultPos;

  public onChange: any = (_) => { /*Empty*/ };
  public onTouched: any = () => { /*Empty*/ };

  ngOnInit(): void {
    if (this.options) {
      this.originalOptions = JSON.parse(JSON.stringify(this.options));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options) {
      this.ngOnInit();
    }
  }

  get internalValue() {
    return this._internalValue;
  }

  set internalValue(val: any) {
    if (val === undefined || val === null || val === '') {
      this._internalValue = '';
      this.onChange(undefined); // Value is rubbish, so don't send back to model propper
      return;
    }

    this._internalValue = val;
    this.onChange(this._internalValue); // Value is good!
  }

  writeValue(value: any) {
    if (value === undefined || value === null) {
      this.selected = [];
      return;
    }
    for (let index = 0; index < this.originalOptions.length; index++) {
      this.originalOptions[index]._order = index;
      if (value.find(i => i[this.value] === this.originalOptions[index][this.value])) {
        this.originalOptions[index].selected = true;
      }
    }
    this.selected = value;
    this.reOrderSelected();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    const self = this;
    this.onTouched = (arg: any) => {
      self.touched = true;
      fn(arg);
    };
  }

  openDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectItem(option) {
    const originalOption = this.findOriginal(option);
    if (!option.selected) {
      option.selected = true;
      this.selected.push(originalOption);
    } else {
      this.selected.splice(this.selected.indexOf(originalOption), 1);
      option.selected = false;
    }
    this.changed.emit(originalOption);
    this.writeValue(this.selected);
  }

  findOriginal(item) {
    return this.options.find(opt => opt[this.value] === item[this.value]);
  }

  reOrderSelected() {
    this.selected.sort((a, b) => {
      if (a.id > b.id) {
        return 1;
      }
      if (a.id < b.id) {
        return -1;
      }
      return 0;
    });
  }

}
